// extracted by mini-css-extract-plugin
export var defaultWrapper = "_m3-3";
export var downloadButton = "_m3-4";
export var fileContainer = "_m3-9 _m3-7";
export var fileContainerBase = "_m3-7";
export var fileContainerFixedHeight = "_m3-8 _m3-7";
export var fileInfo = "_m3-5";
export var fileInfoWidthRestricted = "_m3-6";
export var fileType = "_m3-1";
export var fileTypeName = "_m3-2";
export var image = "_m3-0";
export var link = "_m3-b";
export var overflowEllipsis = "_m3-a";